<template>
<svg viewBox="0 0 16 16" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-DianZanZuiXin`]" width="1em" height="1em" v-bind="$attrs"><g clip-path="url(#svg_d11d05171f__clip0_18957_5975)"><path fill-rule="evenodd" clip-rule="evenodd" d="M0.775879 6.16129C0.775879 3.96691 2.55479 2.18799 4.74918 2.18799C6.09298 2.18799 7.28614 2.43381 8.0052 3.45491C8.72426 2.43381 9.90713 2.18799 11.2509 2.18799C13.4453 2.18799 15.2242 3.96691 15.2242 6.16129C15.2242 10.1346 10.5285 13.7467 8.00006 14.5869C5.47159 13.7467 0.775879 10.1346 0.775879 6.16129ZM1.91797 6.61903C1.91797 4.80395 3.40817 3.33252 5.24644 3.33252C6.17239 3.33252 7.01005 3.80341 7.61341 4.44057C7.8023 4.64004 8.13715 4.64004 8.32604 4.44057C8.9294 3.80341 9.76706 3.33252 10.693 3.33252C12.8132 3.33252 14.0215 4.80395 14.0215 6.61903C14.0215 9.63217 9.77897 12.659 7.96973 13.3643C5.85161 12.6692 2.24928 9.69095 1.91797 6.61903Z"/></g><defs><clipPath id="svg_d11d05171f__clip0_18957_5975"><path d="M0 0H16V16H0z"/></clipPath></defs></svg>
</template>
<script>

export default {
  name: 'IconDianZanZuiXin',
  props: {
    prefix: {
        type: String,
        default: 'LAIDO',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
